import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { GoogleAuthAPI } from '@/api'
import { FilterActions, useFiltersContext, useUserContext } from '@/context'
import { useAPIMutation } from '@/hooks'
import { UserRolesIdMapping } from '@/util'

interface WorkspaceAuthAPI_POST_Body {
  ticket: string
}

function workspaceAuthPost() {
  return { url: `/rusty/workspace_auth`, method: 'post' }
}

export function WorkspaceCallback() {
  const navigate = useNavigate()
  const [, FilterDispatch] = useFiltersContext()
  const { updateUser, setLoading } = useUserContext()

  const { mutateAsync } = useAPIMutation<WorkspaceAuthAPI_POST_Body, GoogleAuthAPI.POST.Response>(workspaceAuthPost())

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ticket = params.get('ticket')
    const rawReturnPath = params.get('return_path') || '/'
    const returnPath = rawReturnPath.startsWith('/oauth/') ? '/' : rawReturnPath

    if (!ticket) {
      navigate('/', { replace: true })
      return
    }

    setLoading(true)

    mutateAsync({ ticket })
      .then(({ data }) => {
        const userData = data?.user
        if (!userData) {
          setLoading(false)
          navigate('/', { replace: true })
          return
        }
        document.cookie = `token=${data.token};path=/`
        updateUser({
          agent: userData?.agent,
          auth_token: data.token,
          email: userData?.email,
          fullName: userData?.full_name,
          id: userData?.id,
          isAgm: userData?.is_agm,
          isBilling: userData?.is_billing,
          isHubManager: userData?.is_hub_manager,
          isSuperAdmin: userData?.is_super_admin,
          isXteam: userData?.is_xteam,
          marketSegmentIds: userData?.market_segment_ids,
          role: userData?.role ? UserRolesIdMapping[userData?.role] : 0,
          homeBlockPermitted: userData?.home_block_permitted,
        })
        if (userData?.market_segment_ids?.length) {
          FilterDispatch(
            FilterActions.setMarketSegments({
              ids: [...userData.market_segment_ids],
              fieldOperationsHubs: [],
              fieldOperationsRegions: [],
              marketSegmentTypes: [],
            }),
          )
        }
        navigate(returnPath, { replace: true })
      })
      .catch(() => {
        setLoading(false)
        navigate('/', { replace: true })
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
